<!-- Main container -->
@if (data) {
  <div class="layout-col full">
    <elder-table
      class="flex"
      dense
      matSort
      [data]="data"
      [idField]="'number'"
      (itemClick)="openDetail($event)"
    >
      <!-- icon -->
      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef style="width: 10px"></th>
        <td mat-cell *matCellDef="let row">
          <mat-icon>work</mat-icon>
        </td>
      </ng-container>
      <!-- number Column -->
      <ng-container matColumnDef="number">
        <th
          mat-header-cell
          *matHeaderCellDef
          style="width: 5%"
          elderNumberCell
          mat-sort-header="workCenterNumber"
          arrowPosition="before"
        >
          {{ 'context.number' | translate }}
        </th>
        <td mat-cell *matCellDef="let wutil" elderNumberCell>{{ wutil.workCenterNumber }}</td>
      </ng-container>
      <!-- workCenterName Column -->
      <ng-container matColumnDef="workCenterName">
        <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header="workCenterName">
          {{ 'context.name' | translate }}
        </th>
        <td mat-cell *matCellDef="let wutil">{{ wutil.workCenterName }}</td>
      </ng-container>
      <!-- capacityUsed in percent Column -->
      <ng-container matColumnDef="capacityUsedPercent">
        <th mat-header-cell *matHeaderCellDef style="width: 5%" elderNumberCell></th>
        <td mat-cell *matCellDef="let wutil" elderNumberCell>
          <span>{{ percent(wutil.capacityUsage) }}</span>
        </td>
      </ng-container>
      <!-- capacityUsed bar Column -->
      <ng-container matColumnDef="capacityUsedBar">
        <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header="capacityUsage">
          {{ 'context.workload' | translate }}
        </th>
        <td mat-cell *matCellDef="let wutil">
          <div class="layout-col place-center-stretch">
            @if (wutil.capacity === 'PT0S') {
              <div class="layout-row place-start-center gap-sm">
                <mat-icon [color]="wutil.capacityUsage > 0.0 ? 'warn' : 'primary'">
                  {{ wutil.capacityUsage > 0.0 ? 'warning' : 'info' }}
                </mat-icon>
                <span class="text-body-small">{{ 'context.unavailable' | translate }}</span>
              </div>
            } @else {
              <app-utilisation-capacity-bar [workCenterUtilisation]="wutil" [barThickness]="20">
              </app-utilisation-capacity-bar>
            }
          </div>
        </td>
      </ng-container>
      <!-- totalWeight Column -->
      <ng-container matColumnDef="totalWeight">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="mat-column-medium"
          elderNumberCell
          mat-sort-header="total.totalWeight.value"
          arrowPosition="before"
        >
          {{ 'context.weight' | translate }}
        </th>
        <td mat-cell *matCellDef="let wutil" elderNumberCell>
          {{ wutil.total.totalWeight | elderQuantity: false : Unit.kg : '1.0-0' }}
        </td>
      </ng-container>
      <!-- itemCount Column -->
      <ng-container matColumnDef="itemCount">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="mat-column-small"
          elderNumberCell
          mat-sort-header="total.itemCount"
          arrowPosition="before"
        >
          {{ 'context.items' | translate }}
        </th>
        <td mat-cell *matCellDef="let wutil" elderNumberCell>{{ wutil.total.itemCount }}</td>
      </ng-container>
      <!-- piecesCount Column -->
      <ng-container matColumnDef="piecesCount">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="mat-column-small"
          elderNumberCell
          mat-sort-header="total.piecesCount"
          arrowPosition="before"
        >
          {{ 'context.pieces' | translate }}
        </th>
        <td mat-cell *matCellDef="let wutil" elderNumberCell>{{ wutil.total.piecesCount }}</td>
      </ng-container>
      <!-- capacityDuration Column -->
      <ng-container matColumnDef="capacityDuration">
        <th mat-header-cell *matHeaderCellDef>{{ 'context.duration' | translate }}</th>
        <td mat-cell *matCellDef="let wutil">
          <span class="text-body-small">{{
            wutil.total.capacityDuration | isoDuration: 'hh:mm'
          }}</span>
        </td>
      </ng-container>
    </elder-table>
  </div>
}
